module.exports = __webpack_public_path__ + "static/media/home_banner.86a06779.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_banner.jpg
// module id = 838
// module chunks = 0